import { CircleCheckBig, CircleEllipsis, CirclePlay, Info, LoaderCircle } from "lucide-react";
import { Badge } from "./ui/badge";

export function BadgeStatus({ finalizado, inProgress }) {
  let status = { label: "Pendente", icon: <Info />, className: "bg-amber-500" };

  if (finalizado) {
    status = { label: "Concluído", icon: <CircleCheckBig />, className: "bg-lime-500 text-white" };
  } else if (inProgress) {
    status = { label: "Em andamento", icon: <CircleEllipsis  />, className: "bg-sky-500 text-[#fff]" };
  }

  return (
    <Badge className={`flex items-center gap-1 ${status.className}`}>
      {status.icon} {status.label}
    </Badge>
  );
}
